document.addEventListener('DOMContentLoaded', function () {
  const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
  
  if (isTouchDevice) return;

  const body = document.body;
  const isHome = body.classList.contains('template-index');
  const isCollection = body.classList.contains('template-collection');
  const collectionHeader = document.getElementById('CollectionHeaderSection');
  const hasCollectionHeader = collectionHeader && collectionHeader.innerHTML.trim() !== '';

  if (isHome || (isCollection && hasCollectionHeader)) {
    document.body.addEventListener('mouseover', function (event) {
      if (event.target.closest('#HeaderWrapper')) {
        const headerWrapper = event.target.closest('#HeaderWrapper');
        const header = headerWrapper.querySelector('#SiteHeader');
        const toolbar = headerWrapper?.querySelector('.toolbar');

        if (!header.classList.contains('site-header--stuck')) {
          headerWrapper.classList.remove('is-light');
          headerWrapper.style.background = 'var(--colorNav)';
          toolbar?.classList.remove('toolbar--transparent');
        }
      }
    });

    document.body.addEventListener('mouseout', function (event) {
      if (event.target.closest('#HeaderWrapper')) {
        const headerWrapper = event.target.closest('#HeaderWrapper');
        const header = headerWrapper.querySelector('#SiteHeader');
        const toolbar = headerWrapper?.querySelector('.toolbar');

        if (!header.classList.contains('site-header--stuck') && !(isCollection && hasCollectionHeader)) {
          headerWrapper.classList.add('is-light');
          headerWrapper.style.background = 'linear-gradient(180deg, rgba(0, 0, 0, .3) 0%, transparent)';
          toolbar?.classList.add('toolbar--transparent');
        }
      }
    });
  }
});
